import React from "react";
import { connect } from "react-redux";
import Container from '@material-ui/core/Container';
import { Typography } from "../components/shared/MaterialUI";

const Dashboard = () => {
  return (
    <Container component="main" maxWidth="lg">
      <Typography variant="h4">Summary of content</Typography>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(Dashboard);
